const validate = values => {
  const errors = {};
  if (!values.userid) {
    errors.userid = 'User id is required';
  }

  if (!values.password) {
    errors.password = "Password is required";
  } else if (values.password.length < 8) {
    errors.password = "Password must be at least 8 characters";
  } else if (!/[A-Z]/.test(values.password)) {
    errors.password = "Password must contain at least one uppercase letter";
  } else if (!/[0-9]/.test(values.password)) {
    errors.password = "Password must contain at least one number";
  } else if (!/[!@#$%^&*]/.test(values.password)) {
    errors.password = "Password must contain at least one special character";
  }

  return errors;
};
export default validate